import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArchiveLockerIcon = createIcon({
  displayName: 'ArchiveLockerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="3"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="21"
        y1="12"
        x2="3"
        y2="12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,6.5v1a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1v-1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,15.5v1a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1v-1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const ArchiveLocker: FC<IconProps> = (props) => {
  return <CustomIcon as={ArchiveLockerIcon} {...props} />
}

export default memo(ArchiveLocker)
